/**
 * Formateo de cantidades para VISUALIZACIÓN en las funcionalidades nuevas
 * (registro agrupado, fabricación/venta de producto, circularidad).
 *
 * Formato es-CO: separador de miles con punto y decimales con coma
 * (p. ej. 1.234.567 y 12.345,67). Usar SOLO al mostrar; nunca sobre los
 * valores que alimentan inputs o cálculos.
 */

const LOCALE = 'es-CO';

/**
 * Unidades: siempre entero, con punto de miles. Ej: 1500 -> "1.500".
 * @param {number|string} n
 * @returns {string}
 */
export const formatUnits = n => Math.round(Number(n) || 0).toLocaleString(LOCALE);

/**
 * Cantidad con decimales fijos y punto de miles. Ej: 12345.6 -> "12.345,60".
 * @param {number|string} n
 * @param {number} decimals  cantidad de decimales (por defecto 2)
 * @returns {string}
 */
export const formatQty = (n, decimals = 2) =>
	(Number(n) || 0).toLocaleString(LOCALE, {
		minimumFractionDigits: decimals,
		maximumFractionDigits: decimals
	});

const groupThousands = digits => {
	const reversed = digits.toReversed();
	const grouped = [];
	for (let i = 0; i < reversed.length; i += 3) {
		grouped.push(
			reversed
				.slice(i, i + 3)
				.toReversed()
				.join('')
		);
	}
	return grouped.toReversed().join('.');
};

/** Texto de un campo entero con punto de miles; ignora los caracteres que no son dígitos ("12a345" → "12.345"). */
export const formatDigitsThousands = value =>
	groupThousands([...String(value)].filter(char => char >= '0' && char <= '9'));

/** Decimal escrito con punto ("1234.5") a punto de miles y coma decimal ("1.234,5"). */
export const formatDecimalThousands = value => {
	const [integerPart, decimalPart] = String(value).split('.');
	const formattedInteger = groupThousands(integerPart.split(''));
	return decimalPart ? `${formattedInteger},${decimalPart}` : formattedInteger;
};
